module.exports = __webpack_public_path__ + "img/03.98f1e6f0.png";